const sendToDataLayer = (pageName, eventType, data) => {
  window.dataLayer = window.dataLayer || []
  const eventData = {
    event: eventType,
    brand: 'olx',
    page: {
      pageType: pageName,
      detail: {
        query: window?.location?.search || '',
      },
    },
    page_name: pageName,
    user_logged_in: Boolean(document?.cookie?.match(/pubaccid=/)),
    ...data,
  }
  window.dataLayer.push(eventData)
}

export { sendToDataLayer }
